import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useValuationNameExist = ({ companyId }: { companyId: string }) => {
  const {
    mutate: checkName,
    data: { isAvailable } = { isAvailable: false },
    isPending,
  } = useAppMutation([QueryKey.VERIFICATION_ID_CHECK], {
    mutationFn: (name: string) =>
      ApiService.post<{ isAvailable: boolean }>(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'events', 'is-valuation-name-exist'],
        },
        { body: { name } },
      ),
  });

  return {
    checkName,
    isAvailable,
    isPending,
  };
};
